import styled from "@theme/utils";
export const AboutCard = styled.div`
    background-color: #f7faff;
    padding: 30px;
    margin-bottom: 30px;
    border-radius: 15px;
    &:last-of-type {
        margin-bottom: 0;
    }
`;
export const SubTitle = styled.h6`
    font-weight: 700;
    line-height: 2.8;
    font-size: 15px;
    margin-bottom: 0px;
    background: linear-gradient(to right, #fc7318 0%, #feb423 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;
export const Title = styled.h4`
    font-weight: 700;
    color: #02126a;
    margin-bottom: 20px;
`;
export const DesText = styled.p``;
